import handleResponseFromEndpoints from './handleResponseFromEndpoints'
import appStateUpdated from 'utils/appStateUpdated'
import initController from './initController'
import saveToStorage from './saveToStorage'
import applyRules from './applyRules'
import initStore from './initStore'

import {
  runCommands,
  registerCommands
} from 'sites/pivothealth.com/scripts/commands/register'

registerCommands()

function controller(config, registry = [], middleware = applyRules) {
  return initController(config)
    .then(handleResponseFromEndpoints)
    .then(data => {
      if (data) {
        initStore(registry.concat(saveToStorage, appStateUpdated), middleware, data)
      }
    })
    .then(runCommands)
}

export default controller
